import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ApiService } from '../../../../../shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { ToastrService } from 'ngx-toastr';
import { param } from 'jquery';
import { catchError, of, Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { PreviewfileComponent } from '../../../previewfile/previewfile.component';
//import { duration } from 'moment';
import { ConfirmationDialogComponent } from '../../../confirmation-dialog/confirmation-dialog.component';



@Component({
  selector: 'app-verify-proposal-details',
  templateUrl: './verify-proposal-details.component.html',
  styleUrl: './verify-proposal-details.component.css'
})


export class VerifyProposalDetailsComponent {
  verifyproposal: FormGroup;
  isSubmitted = false;
  paramValue: string | null = null;
  trainingDelivery: any[] = [];
  implementationDetails: any;
  geographyAndTimeline: any;
  interventionMilestones: any;
  beneficiaries: any;
  certification: any;
  detailedFinancials: any;
  dataSource: any;
  proposalId: any;
  proposalUniqueId: any;
  proposalUserId: any;
  action = false;
  interventionId: any;
  componentId: any;
  approvedTargetMSME: any;
  fromDate: string = '';
  toDate: string = '';
  isApproved = false;
  isEditable: boolean = false;
  uploadError: string | null = null;
  certificateFile: File | null = null;
  ProposalUserId = sessionStorage.getItem('ProposalUserId');
  //isApproved: boolean = false; // Tracks whether the status is "Approved"
  sortedItems: any[] = [];
  //pageSize = 10;
  totalItems: number = 0; // Example total items
  currentPage: number = 1;
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  itemsPerPage: number = 10;
  isShowApprovalFields: boolean = false;
  minToDate: any;
  targetMSMEFromDB: number = 100;
  targetMSME: any;
  maxTargetMSME: number = 0;
  status: any = [];
  //page = 1;
  fileUrl: string | null = null;
  fileName: string = ''; // Store file name separately
  isDisabled = true;
  statusSubscription: Subscription | undefined;
  UserType: string | null = null;
  approvalStatus: any;
  DocumentName: any;
  DocumentPath: any;
  proposalApprovalStatus: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private router: Router,
    public dialog: MatDialog
  ) {
    this.verifyproposal = this.formBuilder.group({
      createdProposalId: new FormControl({ value: '', disabled: true }),
      interventionName: new FormControl({ value: '', disabled: true }),
      componentName: new FormControl({ value: '', disabled: true }),
      noOfEvent: new FormControl({ value: '', disabled: true }),
      pragramNameConduct: new FormControl({ value: '', disabled: true }),
      ssProjectImplementAgency: new FormControl({ value: '', disabled: true }),
      //targetMSME: new FormControl({ value: '', disabled: true }),
      bbImplementAgency: new FormControl({ value: '', disabled: true }),
      measurableOutcomes: new FormControl({ value: '', disabled: true }),
      budgetPerBeneficiary: new FormControl({ value: '', disabled: true }),
      msmeTargetBalance: new FormControl({ value: '', disabled: true }),
      beneficiariesName: new FormControl({ value: '', disabled: true }),
      msmeTargetAchieve: new FormControl({ value: '', disabled: true }),
      status: new FormControl({ value: '', disabled: true }, Validators.required),
      remarks: new FormControl({ value: '', disabled: true }, Validators.required),
      proposedCertificationWorkshops: new FormControl({ value: '', disabled: true }),
      nameofEnterprise: new FormControl({ value: '', disabled: true }),
      fromDate: new FormControl(null, Validators.required), // Initially, no validation
      toDate: new FormControl(null, Validators.required),  // Initially, no validation
      //workOrderCertificate: new FormControl('', Validators.required),
      workOrderCertificate: new FormControl(null),
      duration: [{ value: '', disabled: true }],
      days: [{ value: '', disabled: true }],
      targetMSME: new FormControl({ value: '', disabled: true }, Validators.required),
      //targetMSME: new FormControl(['' [Validators.required]]),

       approvedTargetMSME: [0, [Validators.required, Validators.minLength(1)]],
    });
    this.onStatusChange(); // Attach dynamic validation logic

  }

  ngOnInit(): void {
    
    // Retrieve the parameter value
    this.UserType = sessionStorage.getItem('UserType');

    this.route.params.subscribe(params => {
      this.proposalId = params['proposaluserid'];
      if (params['action'] == 'update') {
        this.action = true;
        this.verifyproposal.get('status')?.enable();
        this.verifyproposal.get('remarks')?.enable();
      }

      this.LoadDetails(this.proposalId);

      this.status = [
        { id: 'Approved', text: 'Approved' },
        { id: 'Rejected', text: 'Rejected' },
        { id: 'Rejected for Query', text: 'Rejected for Query' }
      ];

      /*comment by rp*/
      //this.LoadTargetMSME(this.proposalId);


      //this.verifyproposal.valueChanges.subscribe(() => { this.calculateDuration(); });

    });

    // Watch for changes in the dropdown to toggle validation on the remarks
    this.verifyproposal.get('status')?.valueChanges.subscribe(value => {

      const remarksControl = this.verifyproposal.get('remarks');
      if (value === 'Approved') {
        remarksControl?.clearValidators();
      } else if (value === 'Rejected' || value === 'Rejected for Query') {
        remarksControl?.setValidators([Validators.required, Validators.maxLength(200)]);
      }
      remarksControl?.updateValueAndValidity();
    });

    // Watch for changes in the dropdown to toggle validation on the remarks
    //this.verifyproposal.get('status')?.valueChanges.subscribe(value => {
    //  const remarksControl = this.verifyproposal.get('remarks');
    //  if (value === 'Approve') {
    //    remarksControl?.clearValidators();
    //  } else if (value === 'Reject' || value === 'Reject for Query') {
    //    remarksControl?.setValidators([Validators.required]);
    //  }
    //  remarksControl?.updateValueAndValidity();
    //});

  }

onStatusChange(): void {

  this.statusSubscription = this.verifyproposal.get('status')
    ?.valueChanges.subscribe((status) => {

      const fromDateControl = this.verifyproposal.get('fromDate');
      const toDateControl = this.verifyproposal.get('toDate');
      const workOrderCertificateControl = this.verifyproposal.get('workOrderCertificate');
      const remarksControl = this.verifyproposal.get('remarks');
      const approvedTargetMSMEControl = this.verifyproposal.get('approvedTargetMSME');

      // Clear all validators first
      fromDateControl?.clearValidators();
      toDateControl?.clearValidators();
      workOrderCertificateControl?.clearValidators();
      remarksControl?.clearValidators();
      approvedTargetMSMEControl?.clearValidators();

      // APPROVED
      if (status === 'Approved') {

        fromDateControl?.setValidators([Validators.required]);

        toDateControl?.setValidators([Validators.required]);

        workOrderCertificateControl?.setValidators([
          Validators.required
        ]);

        approvedTargetMSMEControl?.setValidators([
          Validators.required,
          Validators.min(1)
        ]);

        this.isShowApprovalFields = true;
      }

      // REJECTED OR QUERY
      else if (
        status === 'Rejected' ||
        status === 'Rejected for Query'
      ) {

        remarksControl?.setValidators([
          Validators.required
        ]);

        this.isShowApprovalFields = false;

        fromDateControl?.reset();
        toDateControl?.reset();
        workOrderCertificateControl?.reset();
        approvedTargetMSMEControl?.reset();
      }

      // DEFAULT
      else {

        this.isShowApprovalFields = false;

        fromDateControl?.reset();
        toDateControl?.reset();
        workOrderCertificateControl?.reset();
        approvedTargetMSMEControl?.reset();
      }

      // Update validity
      fromDateControl?.updateValueAndValidity();
      toDateControl?.updateValueAndValidity();
      workOrderCertificateControl?.updateValueAndValidity();
      remarksControl?.updateValueAndValidity();
      approvedTargetMSMEControl?.updateValueAndValidity();

    });

}

  // onStatusChange(): void {
  //   this.statusSubscription = this.verifyproposal.get('status')?.valueChanges.subscribe((status) => {
  //     const fromDateControl = this.verifyproposal.get('fromDate');
  //     const toDateControl = this.verifyproposal.get('toDate');
  //     const workOrderCertificateControl = this.verifyproposal.get('workOrderCertificate');
  //     const remarksControl = this.verifyproposal.get('remarks');
  //     const approvedTargetMSMEControl = this.verifyproposal.get('approvedTargetMSME');//rp
  //     this.verifyproposal.get('fromDate')?.clearValidators;
  //     this.verifyproposal.get('toDate')?.clearValidators;
  //     this.verifyproposal.get('workOrderCertificate')?.clearValidators;
  //     this.verifyproposal.get('remarks')?.clearValidators;

  //     if (fromDateControl && toDateControl && workOrderCertificateControl) {
  //       if (status === 'Approved') {
  //         //rp
  //         //fromDateControl.setValidators([Validators.required]);
  //         //toDateControl.setValidators([Validators.required]);
  //         //workOrderCertificateControl.setValidators([Validators.required]);

  //         fromDateControl?.setValidators([Validators.required]);
  //         toDateControl?.setValidators([Validators.required]);
  //         workOrderCertificateControl?.setValidators([Validators.required]);
  //         approvedTargetMSMEControl?.setValidators([Validators.required, Validators.min(1)]);
  //         //rp ends
  //         /* remarksControl?.setValidators([Validators.required])*/
  //         this.isShowApprovalFields = true;
  //         //this.verifyproposal.valueChanges.subscribe(() => { this.calculateDuration(); });
  //         // Set a timeout to delay the execution of calculateDuration
  //         this.verifyproposal.valueChanges.subscribe(() => {

  //           setTimeout(() => {
  //             this.calculateDuration();
  //           }, 2000);  // Delay in milliseconds (e.g., 1000ms = 1 second)
  //         });
  //       } else {
  //         // Clear validators and reset values
  //         fromDateControl.clearValidators();
  //         toDateControl.clearValidators();
  //         workOrderCertificateControl.clearValidators();
  //         // Clear validators and reset values
          
  //         approvedTargetMSMEControl?.clearAsyncValidators();//rp
  //         fromDateControl.reset();
  //         toDateControl.reset();
  //         workOrderCertificateControl.reset();
  //         approvedTargetMSMEControl?.reset();//rp

  //         this.isShowApprovalFields = false;
  //       }
  //       remarksControl?.updateValueAndValidity();

  //       fromDateControl.updateValueAndValidity();
  //       toDateControl.updateValueAndValidity();
  //       approvedTargetMSMEControl?.updateValueAndValidity();//rp

  //       workOrderCertificateControl.updateValueAndValidity();
  //     }
  //   });
  //   //Trying to get data to load data 
  //   //this.verifyproposal.get('fromDate')?.setValue('2025-03-05');
  // }


  LoadDetails(proposalid: string) {
    this.UserType = sessionStorage.getItem('UserType');

    const apiEndpoint = this.UserType === 'MSSIDC'
      ? API_ENDPOINTS.MSSIDC.GETVERIFYPROPOSALBYMSSIDC
      : API_ENDPOINTS.MSSIDC.GETVERIFYPROPOSALDETAILS;

    this.apiService.getRequest(apiEndpoint, { ProposalUserId: proposalid }).subscribe(result => {
      if (result.status && result.data != null) {
        const item1 = result.data.item1;

        this.verifyproposal.patchValue(item1);
        this.verifyproposal.patchValue({
          fromDate: item1.fromDate ? this.formatDate(item1.fromDate) : null,
          toDate: item1.toDate ? this.formatDate(item1.toDate) : null,
          workOrderCertificate: item1.workOrderCertificate
        });

        this.DocumentName = item1.uploadProposalDocument;
        this.DocumentPath = item1.uploadProposalPath;
        this.proposalUniqueId = item1.proposalId;
        this.approvalStatus = item1.status;

        if (item1.proposalApprovalStatus === 1) {
          this.proposalApprovalStatus = true;
        }

        this.verifyproposal.get('beneficiariesName')?.setValue(item1.beneficiariesName);
        this.verifyproposal.get('approvedTargetMSME')?.setValue(item1.approvedTargetMSME);//rp


        this.trainingDelivery = result.data.item2;
        this.implementationDetails = result.data.item3;
        this.geographyAndTimeline = result.data.item4;
        this.interventionMilestones = result.data.item5;
        this.detailedFinancials = result.data.item7;
        
        this.interventionId = item1.interventionId;
        this.componentId = item1.componentId;
        this.targetMSME = item1.targetMSME;
        this.approvedTargetMSME = item1.approvedTargetMSME;
        this.handleFormStatus(item1.status);
        
        if (item1.status == "Pending") {
          this.LoadTargetMSME(this.interventionId, this.componentId, this.targetMSME, this.targetMSME);
        }
        else if (item1.status == "Approved") {
          this.LoadTargetMSME(this.interventionId, this.componentId, this.targetMSME, this.approvedTargetMSME);
        }//rp
      }
    });
  }

  private handleFormStatus(status: string) {
    if (status === "Pending") {
      this.verifyproposal.get('status')?.setValue('');
    }

    if (status === 'Approved') {
      this.verifyproposal.get('status')?.disable();
      this.verifyproposal.get('fromDate')?.disable();
      this.verifyproposal.get('toDate')?.disable();
      this.verifyproposal.get('approvedTargetMSME')?.disable();//rp


      // Use timeout to delay duration calculation
      this.verifyproposal.valueChanges.subscribe(() => {
        setTimeout(() => {
          this.calculateDuration();
        }, 2000);
      });
    } else {
      if (this.UserType === 'MSSIDC') {
        this.verifyproposal.get('status')?.enable();
        this.verifyproposal.get('fromDate')?.enable();
        this.verifyproposal.get('toDate')?.enable();
        this.verifyproposal.get('approvedTargetMSME')?.enable();//rp
      }

      if (status === 'Rejected') {
        this.verifyproposal.get('status')?.disable();
      }
    }
  }



  //LoadDetails(proposalid: string) {
  //  this.UserType = sessionStorage.getItem('UserType');
  //  if (this.UserType === 'MSSIDC') {
  //    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETVERIFYPROPOSALBYMSSIDC, { ProposalUserId: proposalid }).subscribe(
  //      result => {
  //        if (result.status && result.data != null) {

  //          this.verifyproposal.patchValue(result.data.item1);

  //          this.DocumentName = result.data.item1.uploadProposalDocument;
  //          this.DocumentPath = result.data.item1.uploadProposalPath;
  //          if (result.data.item1.proposalApprovalStatus == 1) {
  //            this.proposalApprovalStatus = true;
  //          }

  //          this.verifyproposal.patchValue({
  //            fromDate: result.data?.item1.fromDate ? this.formatDate(result.data.item1.fromDate) : null,
  //            toDate: result.data?.item1.toDate ? this.formatDate(result.data.item1.toDate) : null,
  //            workOrderCertificate: result.data?.item1.workOrderCertificate
  //          });

  //          this.proposalUniqueId = result.data.item1.proposalId; //added by rounak

  //          this.trainingDelivery = result.data.item2;
  //          this.implementationDetails = result.data.item3;
  //          this.geographyAndTimeline = result.data.item4;
  //          this.interventionMilestones = result.data.item5;
  //          this.detailedFinancials = result.data.item7;            

  //          this.verifyproposal.get('beneficiariesName')?.setValue(result.data.item1.beneficiariesName); //added by mayuri
  //          this.approvalStatus = result.data.item1.status;

  //          if (result.data.item1.status == "Pending") {
  //            this.verifyproposal.get('status')?.setValue('');
  //          }

  //          if (result.data.item1.status === 'Approved') {
  //            this.verifyproposal.get('status')?.disable();
  //            this.verifyproposal.get('fromDate')?.disable();
  //            this.verifyproposal.get('toDate')?.disable();
  //            /* this.verifyproposal.valueChanges.subscribe(() => { this.calculateDuration(); });*/

  //            // Set a timeout to delay the execution of calculateDuration
  //            this.verifyproposal.valueChanges.subscribe(() => {

  //              setTimeout(() => {
  //                this.calculateDuration();
  //              }, 2000);  // Delay in milliseconds (e.g., 1000ms = 1 second)
  //            });

  //          } else if (this.UserType == 'MSSIDC') {
  //            this.verifyproposal.get('status')?.enable();
  //            this.verifyproposal.get('fromDate')?.enable();
  //            this.verifyproposal.get('toDate')?.enable();
  //          }

  //          if (result.data.item1.status == "Rejected") {
  //            this.verifyproposal.get('status')?.disable();
  //          }
  //        }
  //      }
  //    );
  //  }
  //  else {
  //    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETVERIFYPROPOSALDETAILS, { ProposalUserId: proposalid }).subscribe(
  //      result => {
  //        if (result.status && result.data != null) {

  //          this.verifyproposal.patchValue(result.data.item1);

  //          this.DocumentName = result.data.item1.uploadProposalDocument;
  //          this.DocumentPath = result.data.item1.uploadProposalPath;
  //          if (result.data.item1.proposalApprovalStatus == 1) {
  //            this.proposalApprovalStatus = true;
  //          }
  //          //console.log(result.data.item1);

  //          //this.verifyproposal.patchValue({
  //          //  fromDate: result.data?.item1.fromDate ? new Date(result.data.item1.fromDate).toISOString().split('T')[0]
  //          //    : null,// result.data?.item1.fromDate,
  //          //  toDate: result.data?.item1.toDate ? new Date(result.data.item1.toDate).toISOString().split('T')[0]
  //          //    : null ,
  //          //  workOrderCertificate: result.data?.item1.workOrderCertificate
  //          //});
  //          //added by sayali.
  //          this.verifyproposal.patchValue({
  //            fromDate: result.data?.item1.fromDate ? this.formatDate(result.data.item1.fromDate) : null,
  //            toDate: result.data?.item1.toDate ? this.formatDate(result.data.item1.toDate) : null,
  //            workOrderCertificate: result.data?.item1.workOrderCertificate
  //          });

  //          // this.verifyproposal.get('txtFromDate')?.setValue('2025-03-05');

  //          this.proposalUniqueId = result.data.item1.proposalId; //added by rounak

  //          this.trainingDelivery = result.data.item2;
  //          this.implementationDetails = result.data.item3;
  //          this.geographyAndTimeline = result.data.item4;
  //          this.interventionMilestones = result.data.item5;
  //          this.detailedFinancials = result.data.item7;
  //          //this.verifyproposal.get('nameOfEnterprise')?.setValue(result.data.item6[0].nameOfEnterprise);

  //          this.verifyproposal.get('beneficiariesName')?.setValue(result.data.item1.beneficiariesName); //added by mayuri
  //          this.approvalStatus = result.data.item1.status;

  //          if (result.data.item1.status == "Pending") {
  //            this.verifyproposal.get('status')?.setValue('');
  //          }

  //          if (result.data.item1.status === 'Approved') {
  //            this.verifyproposal.get('status')?.disable();
  //            this.verifyproposal.get('fromDate')?.disable();
  //            this.verifyproposal.get('toDate')?.disable();
  //            /* this.verifyproposal.valueChanges.subscribe(() => { this.calculateDuration(); });*/

  //            // Set a timeout to delay the execution of calculateDuration
  //            this.verifyproposal.valueChanges.subscribe(() => {

  //              setTimeout(() => {
  //                this.calculateDuration();
  //              }, 2000);  // Delay in milliseconds (e.g., 1000ms = 1 second)
  //            });

  //          } else if (this.UserType == 'MSSIDC') {
  //            this.verifyproposal.get('status')?.enable();
  //            this.verifyproposal.get('fromDate')?.enable();
  //            this.verifyproposal.get('toDate')?.enable();
  //          }

  //          if (result.data.item1.status == "Rejected") {
  //            this.verifyproposal.get('status')?.disable();
  //          }
  //        }
  //      }
  //    );
  //  }
  //}
  //onStatusChange(status: string): void {
  //  this.isApproved = (status === 'Approved');
  //  if (!this.isApproved) {
  //    this.isEditable = false; // Reset edit state
  //    this.verifyproposal.get('targetMSME')?.disable(); // Ensure the field is disabled
  //  }
  //}

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
  }

  //LoadTargetMSME(proposalId: string) {
  //  this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETTARGETMSMEVALUE, { ProposalUserId: proposalId }).subscribe(
  //    result => {
  //      if (result.status) {
  //        if (result.status) {
  //          //console.log(result.data);
  //          this.maxTargetMSME = result.data.targetMSME; // Set maxTargetMSME value from API response

  //          // Patch the form control value (e.g., initialize targetMSME in the form)
  //          this.verifyproposal.patchValue({
  //            targetMSME: this.maxTargetMSME,
  //          });
  //        }

  //      }
  //    }
  //  )
  //}
  //rp
  LoadTargetMSME(interventionId: string, componentId: string, targetMSME: string, approvedTargetMSME: string) {
    
    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GetBalanceTargetMSSIDC, { InterventionId: interventionId, ComponentId: componentId }).subscribe(
      result => {
        if (result.status) {
          //console.log(result.data);
          
          this.maxTargetMSME = result.data[0].TotalTargetMSME; // Set maxTargetMSME value from API response

          // Patch the form control value (e.g., initialize targetMSME in the form)
          this.verifyproposal.patchValue({
            targetMSME: targetMSME,
            approvedTargetMSME: approvedTargetMSME
          });
        }
      }
    )
  }
  //rp ends
  get f() {
    return this.verifyproposal.controls;
  }

  //rp
  validateApprovedTargetMSME(event: any) {
    
    const currentValue = +event.target.value;  // Convert input value to a number

    if (currentValue > this.maxTargetMSME) {
      // If value exceeds maxTargetMSME, set custom error
      //this.verifyproposal.get('targetMSME')?.setErrors({ exceedsTarget: true });
      this.verifyproposal.get('approvedTargetMSME')?.setErrors({ exceedsTarget: true });
    } else {
      // Clear the error if value is valid
      this.verifyproposal.get('targetMSME')?.setErrors(null);
      this.verifyproposal.get('approvedTargetMSME')?.setErrors(null);
    }
  }//rp ends

  toggleEdit() {
    //this.isEditable = !this.isEditable;
    //this.isEditable = true;
    //this.verifyproposal.get('targetMSME')?.enable();
    this.isEditable = !this.isEditable;
    if (this.isEditable) {
      this.verifyproposal.get('targetMSME')?.enable();
    } else {
      this.verifyproposal.get('targetMSME')?.disable();
    }
  }
  updateEdit() {
    //this.isSubmitted = true;
    this.isEditable = true;
    //is.IsProfileCompleted = false;
    // Bind the updated data back to the form group



    if (this.verifyproposal.valid) {

      const statusBy = sessionStorage.getItem('mssidcuserid');
      const ProposalUserId = this.proposalId;

      var formData = {
        ...this.verifyproposal.value,
        ProposalUserId,
        statusBy,

      };

      this.apiService.postRequest(API_ENDPOINTS.MSSIDC.POSTPROPOSALUPDATE, formData).subscribe(res => {


        if (res.status) {
          this.toastr.success(res.message);
          this.router.navigate(['/proposalverification']);

        }
        else {
          this.toastr.error(res.message);
          this.router.navigate(['/proposalverification']);
        }

      });
    }
    catchError(error => {
      let errorMessage = "An error occurred during login.";
      if (error.status === 409) {
        errorMessage = "User already exists";
      } else if (error.status === 400) {
        errorMessage = "Bad Request";
      }
      alert(errorMessage);
      return of(null);
    });

  }

  //onWorkOrderFileChange(event: any) {
  //  const file = event.target.files[0];

  //  if (file) {
  //    const maxSizeInMB = 10;
  //    const fileSizeInMB = file.size / (1024 * 1024); // Convert to MB
  //    this.uploadError = null;
  //    this.verifyproposal.get('workOrderCertificate')?.setErrors(null);
  //    if (file.type !== 'application/pdf') {
  //      this.uploadError = 'Only PDF files are allowed.';
  //      this.certificateFile = null;
  //    } else if (fileSizeInMB > maxSizeInMB) {
  //      this.uploadError = 'File size should not exceed 10 MB.';
  //      this.certificateFile = null;
  //    } else {
  //      this.uploadError = null;
  //      this.certificateFile = file;
  //      this.verifyproposal.get('workOrderCertificate')?.setValue(file.name);
  //    }
  //  }
  //  else {
  //    this.uploadError = 'Please upload a file.';
  //    this.verifyproposal.get('workOrderCertificate')?.setErrors({ required: true });
  //  }
  //}
  //openFile() {
  //  if (this.fileUrl) {
  //    window.open(this.fileUrl, "_blank");
  //  }
  //}

  onWorkOrderFileChange(event: any) {
    const file = event.target.files[0];

    if (file) {
      const maxSizeInMB = 10;
      const fileSizeInMB = file.size / (1024 * 1024); // Convert to MB
      this.uploadError = null;
      this.verifyproposal.get('workOrderCertificate')?.setErrors(null);

      if (file.type !== 'application/pdf') {
        this.uploadError = 'Only PDF files are allowed.';
        this.certificateFile = null;
        this.fileUrl = null;
        this.fileName = '';
      } else if (fileSizeInMB > maxSizeInMB) {
        this.uploadError = 'File size should not exceed 10 MB.';
        this.certificateFile = null;
        this.fileUrl = null;
        this.fileName = '';
      } else {
        this.uploadError = null;
        this.certificateFile = file;
        this.fileName = file.name; // Store file name separately

        // Ensure previous object URLs are revoked to prevent memory leaks
        if (this.fileUrl) {
          URL.revokeObjectURL(this.fileUrl);
        }

        // Create object URL for previewing
        this.fileUrl = URL.createObjectURL(file);
        //console.log("File URL generated:", this.fileUrl); // Debugging
      }
    } else {
      this.uploadError = 'Please upload a file.';
      this.verifyproposal.get('workOrderCertificate')?.setErrors({ required: true });
      this.fileUrl = null;
      this.fileName = '';
    }
  }

  openFile() {
    if (this.fileUrl) {
      window.open(this.fileUrl, "_blank");
    } else {
      alert("No file uploaded or invalid file!");
      //console.log("openFile() called but fileUrl is null");
    }
  }

  sort(column: string): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    this.updateSortedItems();
  }

  updateSortedItems(): void {
    //this.sortedItems = this.apiService.sort(this.dataSource, this.sortColumn, this.sortDirection);
  }

  prepareFormData(): FormData {
    const formData = new FormData();
    //rp
    //const statusBy = sessionStorage.getItem('mssidcuserid');
    //const ProposalUserId = this.proposalId;
    //rp ends
    Object.keys(this.verifyproposal.value).forEach(key => {
      const value = this.verifyproposal.get(key)?.value;
      if (value !== null) {
        formData.append(key, value);
      }

    });


    // Append the file separately
    if (this.certificateFile) {
      formData.append('workOrderCertificateFile', this.certificateFile);  // Add the actual file
    }
    formData.append('ProposalUserId', this.proposalId);
    formData.append('ProposalId', this.proposalUniqueId);
    formData.append('TargetMSME', this.verifyproposal.get('approvedTargetMSME')?.value); //this.approvedTargetMSME);//rp
    //formData.append(statusBy);
    return formData;
  }
  //onFromDateChange() {
  //  const fromDateInput = document.getElementById('fromDate') as HTMLInputElement;
  //  const toDateInput = document.getElementById('txtToDate') as HTMLInputElement;

  //  // Get the selected "From Date" value
  //  const fromDate = fromDateInput.value;

  //  // If "From Date" is valid, set the minimum date for "To Date"
  //  if (fromDate) {
  //    toDateInput.min = fromDate; // Set the min attribute dynamically
  //    toDateInput.value = ''; // Reset the "To Date" value
  //  } else {
  //    // If "From Date" is cleared, remove the min constraint
  //    toDateInput.removeAttribute('min');
  //  }
  //}

  //onFromDateChange() {
  //  const fromDate = this.verifyproposal.get('fromDate')?.value;
  //  this.minToDate = fromDate ? new Date(fromDate) : null;
  //  this.verifyproposal.get('toDate')?.setValue(null); // Reset ‘To Date’ when ‘From Date’ changes
  //}

  onFromDateChange() {
    const fromDate = this.verifyproposal.get('fromDate')?.value;
    this.minToDate = fromDate ? new Date(fromDate).toISOString().split('T')[0] : null; // Format the date as YYYY-MM-DD
    this.verifyproposal.get('toDate')?.setValue(null); // Reset 'To Date'
  }



//   submit() {

//     this.isSubmitted = true;

//     // Manually trigger validation for file upload
//     const statusValue = this.verifyproposal.get('status')?.value;
//     //const workOrderControl = this.verifyproposal.get('workOrderCertificate');//rp

//     //if ((statusValue === 'Rejected' || statusValue === 'Rejected for Query') &&
//     //  !workOrderControl?.value) {
//     //  workOrderControl?.setErrors({ required: true });
//     //}
// console.log(this.verifyproposal);

// Object.keys(this.verifyproposal.controls).forEach(key => {
//   const control = this.verifyproposal.get(key);

//   if (control?.invalid) {
//     console.log('Invalid Control:', key);
//     console.log('Errors:', control.errors);
//     console.log('Value:', control.value);
//   }
// });
//     if (this.verifyproposal.valid) {
//       const statusBy = sessionStorage.getItem('mssidcuserid');
//       const ProposalUserId = this.proposalId;
//       const formDatas = this.prepareFormData();


//       const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
//         width: '400px',
//         data: { message: 'Do you want to proceed with submitting this proposal as \'' + statusValue + '\'? Please confirm before continuing.' }
//       });


//       dialogRef.afterClosed().subscribe(result => {
//         if (result) { // If user confirms deletion   
//           this.apiService.postRequest(API_ENDPOINTS.MSSIDC.POSTPROPOSALUPDATE, formDatas).subscribe(
//             res => {
//               if (res.status) {
//                 this.toastr.success(res.message);
//                 this.router.navigate(['/proposalverification']);

//               }
//               else {
//                 this.toastr.error(res.message);
//                 this.router.navigate(['/proposalverification']);
//               }
//             }
//           );
//         }
//       });
//     }
//     else {
//       this.verifyproposal.markAllAsTouched();
//       return;
//     }
//   }


submit() {

  this.isSubmitted = true;

  const statusValue =
    this.verifyproposal.get('status')?.value;

  // Mark all controls touched
  this.verifyproposal.markAllAsTouched();

  // Update validity
  this.verifyproposal.updateValueAndValidity();

  // Debug form
  console.log('Form Value:', this.verifyproposal.value);
  console.log('Form Status:', this.verifyproposal.status);

  // Check invalid controls
  Object.keys(this.verifyproposal.controls).forEach(key => {

    const control = this.verifyproposal.get(key);

    if (control?.invalid) {

      console.log('Invalid Control:', key);
      console.log('Errors:', control.errors);
      console.log('Value:', control.value);

    }

  });

  // Stop if invalid
  if (this.verifyproposal.invalid) {

    this.toastr.error(
      'Please fill all required fields'
    );

    return;
  }

  // Create FormData
  const formDatas = this.prepareFormData();

  // IMPORTANT:
  // Use set instead of append to avoid duplicate values
  formDatas.set(
    'TargetMSME',
    String(
      this.verifyproposal.get('approvedTargetMSME')?.value || 0
    )
  );

  // Debug FormData
  console.log('------ FormData ------');

  formDatas.forEach((value: any, key: any) => {
    console.log(key, value);
  });

  const dialogRef = this.dialog.open(
    ConfirmationDialogComponent,
    {
      width: '400px',
      data: {
        message:
          `Do you want to proceed with submitting this proposal as '${statusValue}'? Please confirm before continuing.`
      }
    }
  );

  dialogRef.afterClosed().subscribe(result => {

    if (!result) {
      return;
    }

    this.apiService.postRequest(
      API_ENDPOINTS.MSSIDC.POSTPROPOSALUPDATE,
      formDatas
    ).subscribe({

      next: (res: any) => {

        console.log('API Response:', res);

        if (res?.status) {

          this.toastr.success(
            res.message || 'Submitted successfully'
          );

          this.router.navigate([
            '/proposalverification'
          ]);

        }
        else {

          this.toastr.error(
            res?.message || 'Submission failed'
          );

        }

      },

      error: (err: any) => {

        console.log('API Error:', err);
        console.log('Backend Error:', err?.error);

        if (err?.error?.errors) {

          Object.keys(err.error.errors).forEach(key => {

            console.log(
              'Validation Error:',
              key,
              err.error.errors[key]
            );

          });

        }

        this.toastr.error(
          err?.error?.message ||
          err?.error?.title ||
          '400 Bad Request'
        );

      }

    });

  });

}
  back() {
    this.UserType = sessionStorage.getItem('UserType');
    if (this.UserType == 'IA')
      this.router.navigate(['/iaproposalpage']);
    else
      this.router.navigate(['/proposalverification']);
  }

  openFilePreviewDialog(filePath: string, fileName: string): void {
    //var filePath = this.form.get('documentPath')?.value;
    //var fileName = this.form.get('documentName')?.value;

    this.apiService.getFilePreview(filePath).subscribe({
      next: (fileUrl) => {
        const dialogRef = this.dialog.open(PreviewfileComponent, {
          width: '80%',
          height: '80',
          data: { fileUrl, fileName }
        });
      }
    });
  }
  onDownload(filePath: string, fileName: string) {
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error('Download failed:', error);
      }
    });
  }


  // calculateDuration() {
  //   const fDateValue = this.verifyproposal.get('fromDate')?.value;
  //   const tDateValue = this.verifyproposal.get('toDate')?.value;

  //   if (fDateValue && tDateValue) {
  //     const fromDate = new Date(fDateValue);
  //     const toDate = new Date(tDateValue);

  //     if (!isNaN(fromDate.getTime()) && !isNaN(toDate.getTime())) {
  //       let years: number = toDate.getFullYear() - fromDate.getFullYear();
  //       let months: number = toDate.getMonth() - fromDate.getMonth();
  //       let days: number = toDate.getDate() - fromDate.getDate();

  //       // Adjust days if negative
  //       if (days < 0) {
  //         months -= 1;
  //         days += new Date(toDate.getFullYear(), toDate.getMonth(), 0).getDate();
  //       }

  //       // Adjust months if negative
  //       if (months < 0) {
  //         years -= 1;
  //         months += 12;
  //       }

  //       // Total days difference
  //       const totalDays: number = Math.floor((toDate.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24));

  //       // Instead of ignoring years, include them in final output
  //       this.verifyproposal.patchValue(
  //         {
  //           duration: `${years} year(s) ${months} month(s)`,
  //           days: `${days} day(s)`,
  //           approximateMonths: years * 12 + months, // years into months + extra months
  //         },
  //         { emitEvent: false }
  //       );
  //     } else {
  //       console.error('Invalid date values');
  //     }
  //   } else {
  //     console.error('Date values are missing');
  //   }
  // }


  calculateDuration() {

  const fDateValue = this.verifyproposal.get('fromDate')?.value;
  const tDateValue = this.verifyproposal.get('toDate')?.value;

  if (fDateValue && tDateValue) {

    const fromDate = new Date(fDateValue);
    const toDate = new Date(tDateValue);

    if (!isNaN(fromDate.getTime()) && !isNaN(toDate.getTime())) {

      let years = toDate.getFullYear() - fromDate.getFullYear();
      let months = toDate.getMonth() - fromDate.getMonth();
      let days = toDate.getDate() - fromDate.getDate();

      // Adjust days if negative
      if (days < 0) {
        months -= 1;

        days += new Date(
          toDate.getFullYear(),
          toDate.getMonth(),
          0
        ).getDate();
      }

      // Adjust months if negative
      if (months < 0) {
        years -= 1;
        months += 12;
      }

      // Inclusive total days count
      const totalDays =
        Math.floor(
          (toDate.getTime() - fromDate.getTime()) /
          (1000 * 60 * 60 * 24)
        ) + 1;

      this.verifyproposal.patchValue(
        {
          duration: `${years} year(s) ${months} month(s)`,
          days: `${totalDays} day(s)`,
          approximateMonths: years * 12 + months,
        },
        { emitEvent: false }
      );

    } else {
      console.error('Invalid date values');
    }

  } else {
    console.error('Date values are missing');
  }
}
}






  
  //But your current code only puts months = 0 and days = 30, ignoring the year.
  //calculateDuration() {
  //  const fDateValue = this.verifyproposal.get('fromDate')?.value;
  //  const tDateValue = this.verifyproposal.get('toDate')?.value;

  //  //console.log('From Date:', fDateValue, 'To Date:', tDateValue);

  //  // Ensure the dates are not null or undefined
  //  if (fDateValue && tDateValue) {
  //    const fromDate = new Date(fDateValue);
  //    const toDate = new Date(tDateValue);

  //    // Ensure the dates are valid
  //    if (!isNaN(fromDate.getTime()) && !isNaN(toDate.getTime())) {
  //      // Calculate the difference in years, months, and days
  //      let years: number = toDate.getFullYear() - fromDate.getFullYear();
  //      let months: number = toDate.getMonth() - fromDate.getMonth();
  //      let days: number = toDate.getDate() - fromDate.getDate();

  //      // If the days difference is negative, adjust the month and days calculation
  //      if (days < 0) {
  //        months -= 1;
  //        // Get the last day of the previous month (to handle month length correctly)
  //        days += new Date(toDate.getFullYear(), toDate.getMonth(), 0).getDate();
  //      }

  //      // If months difference is negative, adjust the year calculation
  //      if (months < 0) {
  //        years -= 1;
  //        months += 12;
  //      }

  //      // Calculate total days between the two dates (considering leap years and exact month lengths)
  //      const totalDays: number = Math.floor((toDate.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24));

  //      // Calculate months and days based on the total days (if desired)
  //      const approximateMonths: number = Math.floor(totalDays / 30); // This is just an approximation
  //      const remainingDays: number = totalDays % 30;

  //      // Patch the calculated duration to the form ${days} days
  //      this.verifyproposal.patchValue({ duration: `${months}` }, { emitEvent: false });
  //      this.verifyproposal.patchValue({ days: `${days} ` }, { emitEvent: false });
  //      this.verifyproposal.patchValue({ approximateMonths: approximateMonths }, { emitEvent: false });
  //    } else {
  //      console.error('Invalid date values');
  //    }
  //  } else {
  //    console.error('Date values are missing');
  //  }
  //}  




